/* Style imports  */
//import 'normalize.css/normalize.css';
import './styles/vendor.scss';
import './styles/core.scss';
import Keywords from './js/Keywords'

/**
 * Script module imports
 */
import {
   isTouchMode,
   hasWebpSupport,
   slugify,
   isIOS,
   isIE,
   handleScrollDirection
} from './js/utils'
import DailyDealsSlider from './js/daily-deals-slider'
import SliderIntro from './js/slider-intro'
// import FeaturedPromotionsSlider from './js/featured-promotions-slider'
// import './js/the-most-sold'
// import './js/last-units'
import './js/carrusel-banners'

if (typeof regeneratorRuntime === "undefined") {
  require("regenerator-runtime/runtime");
}


// import SimpleModal from './js/simplemodal'


//import Settings from './js/Settings'
//import Brands from './js/marcas'

const isDev = process.env.NODE_ENV === "development"


/**
 * KEY de la hoja de excel principal de contenido
 */
const MAIN_SPREADSHEET_KEY = '1mMaLl4Y3EL9phRvtlo0_PEQ_qClpGLLOaYYs1g7OnnA'

/**
 * KEY de la hoja de excel de 'solo por horas'
 */
const DAILYDEALS_SPREADSHEET_KEY = isDev ? '1YwE83WH-kHH0aYn0JGLwyAGL8ABrB6Umrv_WnwNsalk' : '1YwE83WH-kHH0aYn0JGLwyAGL8ABrB6Umrv_WnwNsalk'

/**
 * Requerir todos los polyfills necesarios
 */
const loadPolyfills = () => {

   /**
    * Verificar soporte del objecto 'Promise'
    * importar polyfill si no hay soporte
    */
   if (typeof window.Promise !== "function") {
      import(/* webpackChunkName: "polyfills" */`promise-polyfill`)
         .then(PromisePolyfill => {
            window.Promise = PromisePolyfill.default
         })
   }

   /**
    * Verificar soporte del objecto 'IntersectionObserver',
    * importar polyfill si no hay soporte
    */
   if (typeof window.IntersectionObserver !== "function") {
      import(/* webpackChunkName: "polyfills" */`intersection-observer`)
   }

   /**
    * Verificar soporte del objecto 'requestAnimationFrame',
    * importar polyfill si no hay soporte
    */
   if (typeof window.requestAnimationFrame === "undefined") {
      import(/* webpackChunkName: "polyfills" */`./js/raf`)
   }
}

/**
 * Agrega clases de detección al elemento 'html'
 */
const addHTMLClasses = () => {

   // Add touch mode class
   if (isTouchMode()) {
      document.documentElement.classList.add('touch-mode')
   }

   if (hasWebpSupport()) {
      document.documentElement.classList.add('supports-webp')
   }

   if (isIOS()) {
      document.documentElement.classList.add('ios')
   }

   if (isIE()) {
      document.documentElement.classList.add('ie')
   }
}

// const addAppDownload =() => {
// const urlAppDownload = !isIOS() ? 'https://play.google.com/store/apps/details?id=cl.sodimac' : 'https://apps.apple.com/pe/app/sodimac-hogar-y-construcci%C3%B3n/id532353705'
//    var bannerAppDownload = document.getElementById('bannerAppDownload');
//    if (bannerAppDownload) {
//       bannerAppDownload.setAttribute('href', urlAppDownload)     
//   }
// }
/**
 * Verifica si el evento principal debe iniciar
 * 
 * @param {*} dateStr 
 */
const checkMainEventStart = (dateStr) => {
   return import('moment')
      .then(moment => {
         return moment.default
      })
      .then(moment => {
         const dateNow = moment().unix()
         const dateStart = moment(dateStr, 'DD-MM-YYYY HH:mm:ss').unix()

         return dateNow >= dateStart
      })
}

/**
 * Manejar navegación del menú
 */
const handleMenuClickNavigation = () => {
   let navbarEl = document.getElementById('swiper-navbar-1')
   const links = navbarEl ? navbarEl.querySelectorAll('.navbar-slider__item') : null
   if (links && links.length) {
      for (let i = 0; i < links.length; i++) {
         links[i].addEventListener('click', e => {
            e.preventDefault()
            const selector = links[i].getAttribute('href')        
           

            setTimeout(() => {              
               const sectionEl = document.querySelector(selector)
               console.log("selector",sectionEl)
               navbarEl = document.getElementById('swiper-navbar-1')
               const { height } = navbarEl.getBoundingClientRect()
               const offsetTop = window.innerWidth < 1000 ? sectionEl.offsetTop - height : sectionEl.offsetTop + 41
               window.scroll(0, offsetTop)
            }, document.querySelector(`${selector} .js-section-loaded`) ? 200 : 500)
         })
      }
   }
}

/**
 * Carga la sección que se le pase de forma diferida (lazyload)
 * 
 * @param {*} target 
 * @param {*} callback 
 */
const lazyLoadSection = (target, callback) => {
   const targetEl = target instanceof HTMLElement ? target : document.querySelector(target)
   import(/* webpackChunkName: "intersectionobserver-controller" */`./js/intersectionobserver-controller`)
      .then(IObserverController => {
         new IObserverController.default(targetEl, { rootMargin: '175px' }, () => {
            // Verificar si la sección ya se cargó
            if (targetEl && targetEl.className.indexOf('js-section-loaded') === -1) {
               setTimeout(() => {
                  targetEl.classList.add('js-section-loaded')
               }, 350)
               callback()
            }
         })
      })
}

;(function (d, $) {
   $(function () {

      $(d).on("click", function (e) {
         var container = $("#fbra_searchBoxContainer");
         if (!container.is(e.target) && container.has(e.target).length === 0) {
            $(".section-navbar-sticky").removeClass("fixed")
            // $(".navBar").removeClass("hidden-menu")
         
         
         }else{
            $(".section-navbar-sticky").addClass("fixed")     
            // $(".navBar").addClass("hidden-menu")
         }
     });

      /**
       * Add referential and support body classes
       */
      addHTMLClasses()
      // addAppDownload()

    

  

      /**
       * Cargar los polyfills necesarios
       */
      loadPolyfills();

      /**
       * Inicializa el slider de vitrinas
       */
      new SliderIntro('#swiper-slider-intro', {
         imageSelector: '.js-swiper-slide-image',
         selectorBtnNext: '.swiper-slider-intro-btn-next',
         selectorBtnPrev: '.swiper-slider-intro-btn-prev',
         selectorPagination: '.swiper-slider-intro-pagination',
         scriptJsonId: 'data-intro-slider'
      })

      /**
       * Inicializa el menu de navegación
       */
      import(/* webpackChunkName: "navbar" */`./js/swiper-navbar`)
         .then(SwiperNavbar => {
            new SwiperNavbar.default('#swiper-navbar-1', {
               jsonScriptId:'data-navBar',
               onInit: (sn) => {
                  /**
                   * Habilita el scrollspy una vez se haya inicializado el menu
                   */
                  import(/* webpackChunkName: "scrollspy" */`./js/scrollspy`)
                     .then(scrollSpy => {
                        scrollSpy.default('#swiper-navbar-1', {
                           sectionClass: '.js-section-scrollspy',
                           menuActiveTarget: '.navbar-slider__item',
                           offset: 100,
                           onScroll: ({ activeItem }) => {
                              /**
                               * Mantener siempre visible el item activo del menú
                               * durante la navegación por scrolling
                               */
                              if (isTouchMode()) {
                                 if (activeItem && !sn.navigatingByClick && sn.activeIndex !== activeItem.dataset.index) {
                                    sn.handleNavItemClick(null, activeItem)
                                 }
                                 sn.navigatingByClick = false
                              }
                           }
                        })
                     })
      
                  handleMenuClickNavigation();
               },
               onLoadData: (res) => {
                  /**
                   * Extraer y renderizar keywords por cada sección de categorías
                   */
                  res.filter((elemento) => {  
                     return elemento.gsx$keywords.$t !== ""
                  }).forEach((item) => {  
                     let itemHmtl = ` <h3 class="keyword-heading">Encuentra mas productos en: </h3> `
      
                     try {
                        item.gsx$keywords.$t.match(/(?:\[).+?(?:\])/g).forEach(function (elemento) {
                           const splitStrig = elemento.replace('[', '').replace(']', '').split(',');        
                           itemHmtl += `<a class="item-keyword" href="/sodimac-pe/${splitStrig[1].charAt(0) ==='a' ?'content':'landing'}/${splitStrig[1]}/${slugify(splitStrig[0])}/?cid=${splitStrig[2]}">${splitStrig[0]}</a>`                                   
                        });
                        
                        const keywordsEl = document.querySelector('#section-' + slugify(item.gsx$name.$t) + ' .section-promo__keywords') 
                        if (keywordsEl) {
                           keywordsEl.innerHTML = itemHmtl
                        }
                     } catch(err) {
                        console.error(err)
                     }
                  })
               }
            })
         })

      /**
       * La sección se cargará solamente cuando se encuentre dentro del viewport
       */
      lazyLoadSection('.js-section-dailydeals', () => {
         /**
          * Inicializa individualmente los items del "Solo por horas"
          */
         import(/* webpackChunkName: "daily-deals" */`./js/daily-deals`)
            .then(DailyDeals => {
               let ddSwiper = null

               /**
                * Inicializa o actualiza el slider para la sección de "Solo por horas"
                */
               function initOrUpdateSwiperInstance() {
                  if (!ddSwiper) {
                     ddSwiper = new DailyDealsSlider().swiper
                  } else {
                     ddSwiper.update()
                  }
               }

               function handleOnInit(d) {
                  // console.log("imprime d " , d)
                  if (d && d.isDataLoaded) {
                     // $(".swiper-container-solohoras")[0].classList.remove('hidden')
                     // $(".swiper-container-solohoras")[0].classList.add('js-item-loaded')
                  }
                  initOrUpdateSwiperInstance()
               }

               function handleOnEnd(d) {
                  // console.log("imprime d " , d.isDataLoaded)
                  if (d && !d.isDataLoaded) {
                     // $(".swiper-container-solohoras")[0].classList.add('hidden')
                     // $(".swiper-container-solohoras")[0].classList.remove('js-item-loaded')
                  }
               }

               new DailyDeals.default('#daily-deals-homecenter-1', {
                  renderToExternalCountdown: true,
                  //dataSheetURL: '/static/campanas/cybersodimac/eventos-2019/dailyDealsHomecenter.json?1234567890',
                  dataSheetURL: `https://spreadsheets.google.com/feeds/list/${DAILYDEALS_SPREADSHEET_KEY}/1/public/values?alt=json`,
                  onInit: d => handleOnInit(d),
                  onEnd: d => handleOnEnd(d)
               })
      
               new DailyDeals.default('#daily-deals-homecenter-2', {
                  renderToExternalCountdown: false,
                  //dataSheetURL: '/static/campanas/cybersodimac/eventos-2019/dailyDealsHomecenter.json?1234567890',
                  dataSheetURL: `https://spreadsheets.google.com/feeds/list/${DAILYDEALS_SPREADSHEET_KEY}/2/public/values?alt=json`,
                  onInit: d => handleOnInit(d),
                  onEnd: d => handleOnEnd(d)
               })
      
               new DailyDeals.default('#daily-deals-constructor-1', {
                  renderCountdown: false,
                  //dataSheetURL: '/static/campanas/cybersodimac/eventos-2019/dailyDealsConstructor.json?1234567890',
                  dataSheetURL: `https://spreadsheets.google.com/feeds/list/${DAILYDEALS_SPREADSHEET_KEY}/3/public/values?alt=json`,
                  onInit: d => handleOnInit(d),
                  onEnd: d => handleOnEnd(d)
               })
      
               new DailyDeals.default('#daily-deals-constructor-2', {
                  renderCountdown: false,
                  //dataSheetURL: '/static/campanas/cybersodimac/eventos-2019/dailyDealsConstructor.json?1234567890',
                  dataSheetURL: `https://spreadsheets.google.com/feeds/list/${DAILYDEALS_SPREADSHEET_KEY}/4/public/values?alt=json`,
                  onInit: d => handleOnInit(d),
                  onEnd: d => handleOnEnd(d)
               })
      
               new DailyDeals.default('#daily-deals-adicional', {
                  renderCountdown: false,
                  //dataSheetURL: '/static/campanas/cybersodimac/eventos-2019/dailyDealsConstructor.json?1234567890',
                  dataSheetURL: `https://spreadsheets.google.com/feeds/list/${DAILYDEALS_SPREADSHEET_KEY}/5/public/values?alt=json`,
                  onInit: d => handleOnInit(d),
                  onEnd: d => handleOnEnd(d)
               })
            })
      })

      /**
       * Inicializa el carrusel de productos más vendidos
       */
      // lazyLoadSection('.section-best-seller', () => {  
      //    new Brands('#swiper-best-seller', {
      //    sheetIndex: 14,
      //    sheetKey: MAIN_SPREADSHEET_KEY
      // })
      // })

      /**
       * Inicializa el carrusel de últimas unidades
       */
      // lazyLoadSection('.section-latest-product', () => {
      //    new Brands('#swiper-latest-product', {
      //       sheetIndex: 13,
      //       sheetKey: MAIN_SPREADSHEET_KEY
      //    })

      // })

      /**
       * Inicializa la sección de "Marcas Sodimac"
       */
      /*lazyLoadSection('.js-section-brands', () => {
         new Brands('#swiper-brands', {
            sheetIndex: 13,
            sheetKey: MAIN_SPREADSHEET_KEY
         })
      }) */

      /**
       * Setea color y texto seccion Daily-deals
       */
      /*new Settings('', {
         sheetIndex: 16,
         sheetKey: MAIN_SPREADSHEET_KEY,
         selectorWDDeals: '.wrapper-fondo-deals',
         selectorTextDDeals: '.ddeals-text-hurryup'
      }) */
       /**
       * Inicializa slider promotions
       */

      // new FeaturedPromotionsSlider()
           /**
       * Setea Keyword desde el drive
       */
      new Keywords('', {
         sheetIndex: 1,
         sheetKey: MAIN_SPREADSHEET_KEY
      }) 

      lazyLoadSection('#js-dg-homeofficeschool', () => {
         import(/* webpackChunkName: "dynamic-grid" */`./js/dynamic-grid`)
            .then(DynamicGrid => {
               new DynamicGrid.default('#js-dg-homeofficeschool', {
                  sheetIndex: 3,
                  sheetKey: MAIN_SPREADSHEET_KEY,
                  enableCarousel: true,
                  carouselNav: true,
                  hasProdCards: true,
                  carouselMobileOnly: true,
                  catImgPrefix: 'cpo-may-'
               })
            })
      })

    /**
      * Grillas dinámicas para sección desctacados / banners categorías 
      */

      lazyLoadSection('#js-dg-entretenimiento', () => {
         import(/* webpackChunkName: "dynamic-grid" */`./js/dynamic-grid`)
            .then(DynamicGrid => {
               new DynamicGrid.default('#js-dg-entretenimiento', {
                  sheetIndex: 4,
                  sheetKey: MAIN_SPREADSHEET_KEY,
                  enableCarousel: true,
                  carouselNav: true,
                  hasProdCards: true,
                  carouselMobileOnly: true,
                  catImgPrefix: 'cpo-may-'
               })
            })
      })


      lazyLoadSection('#js-dg-linea-blanca', () => {
         /**
          * Grillas dinámicas para sección desctacados / banners categorías 
          */
         import(/* webpackChunkName: "dynamic-grid" */`./js/dynamic-grid`)
            .then(DynamicGrid => {
               //import('./styles/sections/_section-banners-content.scss')
               new DynamicGrid.default('#js-dg-linea-blanca', {
                  sheetIndex: 5,
                  sheetKey: MAIN_SPREADSHEET_KEY,
                  enableCarousel: true,
                  carouselNav: true,
                  hasProdCards: true,
                  carouselMobileOnly: true,
                  catImgPrefix: 'cpo-may-'
               })
            })
      })

      lazyLoadSection('#js-dg-fitness', () => {
         import(/* webpackChunkName: "dynamic-grid" */`./js/dynamic-grid`)
            .then(DynamicGrid => {
               new DynamicGrid.default('#js-dg-fitness', {
                  sheetIndex: 6,
                  sheetKey: MAIN_SPREADSHEET_KEY,
                  enableCarousel: true,
                  carouselNav: true,
                  hasProdCards: true,
                  carouselMobileOnly: true,
                  catImgPrefix: 'cpo-may-'
               })
            })
      })

      lazyLoadSection('#js-dg-sala-comedor-y-dormitorio', () => {
         import(/* webpackChunkName: "dynamic-grid" */`./js/dynamic-grid`)
            .then(DynamicGrid => {
               new DynamicGrid.default('#js-dg-sala-comedor-y-dormitorio', {
                  sheetIndex: 7,
                  enableCarousel: true,
                  carouselNav: true,
                  sheetKey: MAIN_SPREADSHEET_KEY,
                  hasProdCards: true,
                  carouselMobileOnly: true,
                  catImgPrefix: 'cpo-may-'
               })
            })
      })


      lazyLoadSection('#js-dg-aseo-y-desinfeccion', () => {
         import(/* webpackChunkName: "dynamic-grid" */`./js/dynamic-grid`)
            .then(DynamicGrid => {
               new DynamicGrid.default('#js-dg-aseo-y-desinfeccion', {
                  sheetIndex: 8,
                  sheetKey: MAIN_SPREADSHEET_KEY,
                  enableCarousel: true,
                  carouselNav: true,
                  hasProdCards: true,
                  carouselMobileOnly: true,
                  catImgPrefix: 'cpo-may-'
               })
            })
      })

      lazyLoadSection('#js-dg-terrazas-jardin-y-mascotas', () => {
         import(/* webpackChunkName: "dynamic-grid" */`./js/dynamic-grid`)
            .then(DynamicGrid => {
               new DynamicGrid.default('#js-dg-terrazas-jardin-y-mascotas', {
                  sheetIndex: 9,
                  sheetKey: MAIN_SPREADSHEET_KEY,
                  enableCarousel: true,
                  carouselNav: true,
                  hasProdCards: true,
                  carouselMobileOnly: true,
                  catImgPrefix: 'cpo-may-'
               })
            })
      })
      
      lazyLoadSection('#js-dg-herramientas-autos', () => {
         import(/* webpackChunkName: "dynamic-grid" */`./js/dynamic-grid`)
            .then(DynamicGrid => {
               new DynamicGrid.default('#js-dg-herramientas-autos', {
                  sheetIndex: 10,
                  sheetKey: MAIN_SPREADSHEET_KEY,
                  enableCarousel: true,
                  carouselNav: true,
                  hasProdCards: true,
                  carouselMobileOnly: true,
                  catImgPrefix: 'cpo-may-'
               })
            })
      })

      lazyLoadSection('#js-dg-banos-cocinas', () => {
         import(/* webpackChunkName: "dynamic-grid" */`./js/dynamic-grid`)
            .then(DynamicGrid => {
               new DynamicGrid.default('#js-dg-banos-cocinas', {
                  sheetIndex: 11,
                  sheetKey: MAIN_SPREADSHEET_KEY,
                  enableCarousel: true,
                  carouselNav: true,
                  hasProdCards: true,
                  carouselMobileOnly: true,
                  catImgPrefix: 'cpo-may-'
               })
            })
      })

      lazyLoadSection('#js-dg-renueva-tus-espacios', () => {
        
         import(/* webpackChunkName: "dynamic-grid" */`./js/dynamic-grid`)
            .then(DynamicGrid => {
               new DynamicGrid.default('#js-dg-renueva-tus-espacios', {
                  sheetIndex: 13,
                  sheetKey: MAIN_SPREADSHEET_KEY,
                  enableCarousel: true,
                  carouselNav: true,
                  hasProdCards: true,
                  carouselMobileOnly: true,
                  catImgPrefix: 'cpo-may-'
               })
            })
      })

      lazyLoadSection('#js-dg-mantenimiento-y-seguridad', () => {
         import(/* webpackChunkName: "dynamic-grid" */`./js/dynamic-grid`)
            .then(DynamicGrid => {
               new DynamicGrid.default('#js-dg-mantenimiento-y-seguridad', {
                  sheetIndex: 12,
                  sheetKey: MAIN_SPREADSHEET_KEY,
                  enableCarousel: true,
                  carouselNav: true,
                  hasProdCards: true,
                  carouselMobileOnly: true,
                  catImgPrefix: 'cpo-may-'
               })
            })
      })

      



    
   })

   /**
    * Añade comportamiento sticky al menú de categorías
    */
   if (! isIE()) { // Ensure Not initialize on IE
      import(/* webpackChunkName: "stickyfilljs" */`stickyfilljs`)
         .then(Stickyfill => {
            Stickyfill.add(d.querySelector('.js-section-navbar'));
         })
   }

  

   /**
    * Inicializa la carga de imágenes de forma diferida (lazy load)
    */
   import(/* webpackChunkName: "lazy-images" */`./js/lazy-images`)
      .then(LazyImages => {
         new LazyImages.default()
      })

   /**
    * Manejador de dirección de scroll (scroll up / scroll down)
    */
   handleScrollDirection()


   /**
    * Activar visibilidad de la wincha
    */
   d.body.classList.add('showTopBanner')

   /**
    * Agregar clase al body para definir si la Preventa está en curso
    */
   d.body.classList.add('is-presale')

   /**
    * Verificar el inicio del evento principal.
    */
   checkMainEventStart('10-11-2019 22:20:59')
      .then(mustStart => {
         if (mustStart) {
            d.body.classList.remove('is-presale')
         }
      })

   /**
    * Modal promoción Navidad
    */

    
 
   // new SimpleModal({
   //    triggerSelector: '.js-open-modal'
   // })

})(document, jQuery);


